import { FormValidationRule } from "../types";
import {
    validROISortCodes,
    validNISortCodes
} from "../controls/sort-code/valid-sort-codes";

const isValidSortCode = (sortCode: string, jurisdiction: string) => {
    switch (jurisdiction) {
        case "roi":
            return validROISortCodes.includes(sortCode);
        case "ni":
            return validNISortCodes.includes(sortCode);
        case "both":
            return (
                validROISortCodes.includes(sortCode) ||
                validNISortCodes.includes(sortCode)
            );
        default:
            return false;
    }
};

const getErrorMessage = (jurisdiction: string) => {
    let jurisdictionLabel = "";
    switch (jurisdiction) {
        case "roi":
            jurisdictionLabel = "the Republic of Ireland";
            break;
        case "ni":
            jurisdictionLabel = "Northern Ireland";
            break;
        case "both":
        default:
            jurisdictionLabel = "the Republic of Ireland or Northern Ireland";
            break;
    }
    return `We can only accept valid sort codes from ${jurisdictionLabel}. Please check the sort code you have entered and try again.`;
};

const sortCode: FormValidationRule = (c, v) => {
    let valid = true;
    let invalidSortCodeMessage = "";
    
    if (c.type === "sort-code" && v && v.length) {
        const value = v.replace(/-/g, "");
        if (value.length === 4 || value.length !== 6) {
            valid = false;
            invalidSortCodeMessage = "Please use two digits on each input box.";
        } else if (!isValidSortCode(value, c.field_sort_code_jurisdiction)) {
            valid = false;
            invalidSortCodeMessage =
                c.errorMessage || getErrorMessage(c.field_sort_code_jurisdiction);
        }
    }
    return [valid, invalidSortCodeMessage];
};

export default sortCode;
